export const defaultCode = `import os
import uvicorn
from fastapi import FastAPI

app = FastAPI()
@app.post("/hello")
def read_root():
    # Combining functions within the f-string
    return {"data" : "hello world"}

def main():
    # Use uvicorn.run for a straightforward, synchronous startup
    uvicorn.run(
        app,
        host="0.0.0.0",
        port=int(os.environ['PORT'])
    )

if __name__ == "__main__":
    main()`
